import { useEffect, useState } from "react";
import { onValue, ref, Unsubscribe } from "firebase/database";
import { db } from "../firebase";
import {
    Box,
    Button,
    Center,
    Text,
    Image,
    useColorModeValue,
} from "@chakra-ui/react";
import { useChatPdf } from '../helpers/useChatPdf';
import ChatMessages from "../components/ChatMessages";

export default function ChatDisplayPage() {
    const [chatMessages, setChatMessages] = useState<any>();
    const [chatConfigs, setChatConfigs] = useState<any>();
    const [chatId, setChatId] = useState<string>('');
    const [allReferences, setAllReferences] = useState<string[]>([]);
    const { downloadPdf, isGenerating } = useChatPdf('chatsoc_conv.pdf');

    // Theme Variables
    const mainBg = useColorModeValue("#ffffff", "gray.800");
    const topBarBg = useColorModeValue("#f1f1f1", "gray.700");
    const topBarBorderColor = useColorModeValue("gray", "gray.600");
    const titleColor = useColorModeValue("black", "white");
    const dateColor = useColorModeValue("gray", "gray.400");
    const learnMoreColor = useColorModeValue("black", "blue.300");
    const downloadButtonColorScheme = "gray";

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const chatString = params.get("chatId");
        const unsubscribeFunctions: Unsubscribe[] = [];

        if (chatString) {
            const publicChatsRef = ref(db, 'publicChats');
            const unsubPublicChats = onValue(publicChatsRef, (snapshot) => {
                const val = snapshot.val();
                if (val && Object.keys(val).includes(chatString)) {
                    setChatId(chatString);
                    const chatConfigsRef = ref(db, 'chats/' + chatString);
                    const unsubConfigs = onValue(chatConfigsRef, (snapshot) => {
                        const configs = snapshot.val()
                        if (configs) {
                            setAllReferences(configs.references);
                            setChatConfigs(configs);
                            const chatMsgsRef = ref(db, 'rawChatMessages/' + chatString);
                            const unsubMsgs = onValue(chatMsgsRef, (snapshot) => {
                                const msgs = snapshot.val()
                                if (msgs) {
                                    setChatMessages(msgs)
                                }
                            });
                            unsubscribeFunctions.push(unsubMsgs);
                        }
                    });
                    unsubscribeFunctions.push(unsubConfigs);
                }
            });
            unsubscribeFunctions.push(unsubPublicChats);
        }

        return () => {
            unsubscribeFunctions.forEach((unsub) => unsub());
        };
    }, [])

    return (
        <Box overflowY="auto" bg={mainBg} id="chat-container">
            <Box bg={topBarBg} borderBottom=".5px solid" borderColor={topBarBorderColor} padding=".5%" fontFamily={"Elza, sans-serif"}>
                <Text fontSize="20px" fontWeight={500} textAlign="center" color={titleColor}>{chatConfigs && chatConfigs.title}</Text>
                <Text fontSize="14px" fontWeight={300} color={dateColor} textAlign="center">{chatConfigs && new Date(chatConfigs.time).toDateString()}</Text>
            </Box>
            <Center marginTop="1%" marginBottom="-2%">
                <Box cursor="pointer" onClick={() => { window.location.href = 'https://www.sullivanoncomp.com/chatsoc' }} h="15%" w="15%">
                    <Image src="chatsoc_logo.svg" alt="ChatSoc Logo" />
                    <Text textAlign="right" color={learnMoreColor}>Learn more</Text>
                </Box>
            </Center>
            {chatMessages && <ChatMessages status={"completed"} chatMessages={chatMessages} currentChat={chatId} allReferences={allReferences} apiAddress='' />}
            <Center margin="2%">
                <Button
                    onClick={() => {
                        downloadPdf({
                            title: chatConfigs?.title,
                            messages: chatMessages ?? [],
                            allReferences,
                            time: chatConfigs?.time,
                        });
                    }}
                    isLoading={isGenerating}
                    loadingText="Preparing PDF"
                    isDisabled={!chatMessages}
                    marginTop="20px"
                    colorScheme={downloadButtonColorScheme}
                    variant="outline"
                >
                    Download Chat as PDF
                </Button>
            </Center>
        </Box>

    )
}
